<template>
  <v-container>
    <LoadingBar v-if="loading" />

    <div v-else>
      <v-container class="pa-6 pt-10" fluid>
        <v-row>
          <v-col cols="12" class="col-md-6">
            <h1>{{ $t("Games Experience") }}</h1>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn @click="edit = true" v-show="edit == false">
              {{ $t("Edit Pages") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="services-list">
        <v-row dense>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            xl="2"
            class="pa-0"
            v-show="edit == false"
          >
            <v-list>
              <v-list-item-group v-model="tab">
                <v-list-item
                  v-for="(page, index) in posts"
                  :key="page.id"
                  @click="selectTab(index + 1)"
                  class="active"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ page.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      page.description
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            xl="2"
            class="pa-0"
            v-show="edit == true"
          >
            <v-list subheader three-line>
              <draggable
                :list="posts"
                group="my-group"
                @start="drag = true"
                @end="drag = false"
              >
                <div v-for="page in posts" :key="page.id">
                  <v-list-item link>
                    <v-list-item-icon>
                      <v-icon>mdi-drag</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="">{{
                        page.name
                      }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <router-link :to="`/games/experience/edit/${$route.params.id}/${page.id}`">
                        <v-btn icon class="mt-5">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </router-link>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-btn icon class="mt-5" @click="deletePage(page.id)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </div>
                <div slot="header">
                  <v-btn class="mb-5" @click="addPage">{{
                    $t("Add Content")
                  }}</v-btn>
                </div>
                <div slot="footer">
                  <v-btn class="mb-5" @click="doneEditing">
                    {{ $t("Done Editing") }}</v-btn
                  >
                </div>
              </draggable>
            </v-list>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="6"
            lg="9"
            xl="10"
            class="pa-0"
            v-show="edit == false"
          >
            <div
              v-for="index in posts.length"
              :key="`${index}-tab-item`"
              :ref="`tab-${index - 1}`"
              v-show="tab == index - 1"
            >
              <editor
                :data="posts[index - 1].content"
                :readOnly="true"
                :ref="`tab-${index - 1}`"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import editor from "../../components/editor.vue";
import draggable from "vuedraggable";
import gameProvider from "@/modules/Games/data/games";

export default {
  name: "GameExperiencePage",
  route: {
    path: "/games/Experience/:id",
    name: "Game Experience",
  },
  data: () => ({
    loading: false,
    edit: false,
    tab: 0,
    posts: [
    ],
    items: [
      { title: "Dashboard", icon: "mdi-view-dashboard" },
      { title: "Photos", icon: "mdi-image" },
      { title: "About", icon: "mdi-help-box" },
    ],
    right: null,
  }),
  components: {
    editor,
    draggable,
    LoadingBar: () => import("../../components/LoadingBar.vue"),
  },
  beforeMount() {
    this.getExperiencePages();
  },
  watch: {
    $route(to) {
      let split = String(to.path).split("/");
      this.posts.forEach((page, index) => {
        if (split[split.length - 1] == page.id) {
          this.tab = index;
        }
      });
    },
  },
  methods: {
    selectTab(index) {
      this.tab = index;
    },
    addPage() {
      this.posts.push({
        id: Math.floor(Math.random() * (new Date().getTime() / 1000 - 0) + 0),
        name: "New Page - " + new Date(),
        description: "",
        content: {
          version: "2.22.2",
          time: 1641316352144,
          blocks: [
            {
              type: "paragraph",
              id: "3OM1NrdNHg",
              data: { text: "I am Content!" },
            },
          ],
        },
        image: "",
        order: this.posts.length,
      });
      this.saveGame();
    },
    deletePage(id) {
      this.loading = true;
      this.posts.forEach((page, index) => {
        if (page.id == id) {
          this.posts.splice(index, 1);
        }
      });
      this.loading = false;
      this.saveGame();      
    },
    async doneEditing() {

      this.edit = !this.edit
      this.saveGame();
    },
    async saveGame() {

      let self = this;
      gameProvider.getEvent(this.$route.params.id).then(function (event) {
        event.experiencePages = self.posts;
        gameProvider.editSingleGame(self.$route.params.id, event).then(function () {
          console.log("Saved");
        });
      });
    },
    reset() {
      this.getExperiencePages();
      this.edit = false;
    },
    async getExperiencePages() {
      let self = this;
      gameProvider
        .getExperiencePages(self.$route.params.id)
        .then(function (posts) {
          self.posts = posts;
          let split = String(self.$route.path).split("/");
          self.posts.forEach((page, index) => {
            if (split[split.length - 1] == page.id) {
              self.tab = index;
            }
          });
        });
    },
    copyClipboard(link) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$app.alert(this.$t("Link Copied!"));
        })
        .catch((err) => {
          console.log("Something went wrong", err);
        });
    },
  },
  compare(a, b) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  },
  mounted: function () {},
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}
.services-list {
  .v-card {
    min-height: 250px;
  }
}
</style>
